import { InjectionToken } from "@angular/core";
import { Language, Platform } from "@bca-core/models/_enums";

export const APP_CONFIG = new InjectionToken<IAppConfiguration>("APP_CONFIG", {
  providedIn: "root",
  factory: () => Object(),
});

export interface IAppConfiguration {
  api_url_pasfoto: string;
  api_url_bca: string;
  api_version: string;
  api_url_rio: string;
  api_key_rio: string;
  redirect_url: string;
  condition_urls: {
    terms_and_conditions: string;
    terms_and_conditions_btm: string;
    terms_and_conditions_bike: string;
    terms_and_conditions_product: string;
  };
  taxRate: number;
  taxPercentage: number;
  isMobileDevice: boolean;
  staticsPath: string;
  application_form_nl_url: string;
  application_form_eng_url: string;
}
